//core
import React from "react";
import { Box } from "@mui/material";

//styles
import { useStyles } from "./styles";

//components
import NetworkBalanceItem from "./components/NetworkBalanceItem";

interface IAgentNetworkBalanceProps {
  data: any;
}

const AgentNetworkBalance: React.FC<IAgentNetworkBalanceProps> = ({
  data,
}): React.ReactElement => {
  const styles = useStyles();

  return (
    <>
      {data?.networkBalance && data?.networkBalance?.length > 0 ? (
        <Box className={styles.block}>
          {data.networkBalance.map((el: any, i: number) => {
            return (
              <NetworkBalanceItem
                key={`${el.currency}-${i}`}
                networkBalanceItem={el}
                agentId={data.id}
              />
            );
          })}
        </Box>
      ) : (
        <>{'—'}</>
      )}
    </>
  );
};

export default AgentNetworkBalance;
